import React, { useEffect, useState } from 'react';
import FormDialog from '../FormControl/FormDialog';
import { Checkbox, FormControl, FormControlLabel, FormHelperText, TextField } from '@mui/material';
import DefaultButton from '../FormControl/DefaultButton';
import ErrorButton from '../FormControl/ErrorButton';
import { FormDirty, FormErrors, FormValidationSchema } from '../FormControl/Form/Form';
import * as Yup from 'yup';
import useTranslate from '../Translate/useTranslate';
import UserApi from '../../service/UserApi';
import { useAuthentication } from '../../reducer/authentication';
import UserPhotoInput from '../UserPhoto/UserPhotoInput';

export interface ChangePhotoDialogData {
    photo: Blob | File | null;
}

export interface ChangePhotoDialogState {

}

export interface ChangePhotoDialogProps {
    changePhotoDialogOpen: boolean;
    onSubmit: (data: ChangePhotoDialogData) => any;
    onCancel: () => any;
}

function ChangePhotoDialog(props: ChangePhotoDialogProps) {

    const { onCancel, changePhotoDialogOpen } = props;
    const userApi = new UserApi();
    const t = useTranslate();
    const { user } = useAuthentication();
    const [photoUrl, setPhotoUrl] = useState<string | null>(null);

    useEffect(() => {
        if (user && changePhotoDialogOpen && user.photo) {
            setPhotoUrl(userApi.getPhotoUrl(user.id, user.photo));
        } else {
            setPhotoUrl(null);
        }
    }, [changePhotoDialogOpen])

    function onSubmitHandler(data: ChangePhotoDialogData, errors: FormDirty<any>) {
        const { onSubmit } = props;
        onSubmit(data);
    }

    async function validateForm(data: ChangePhotoDialogData): Promise<FormErrors<ChangePhotoDialogData>> {
        if (!(data.photo instanceof File)) {
            return {
                photo: "Selecione uma foto"
            };
        }
        return {};
    }

    return (
        <FormDialog
            show={changePhotoDialogOpen}
            title={'Alterar foto'}
            dismiss={() => onCancel()}
            onSubmit={(values, errors, dirty) => {
                const { photo } = values;
                if (!dirty && photo) {
                    onSubmitHandler({ photo }, errors);
                }
            }}
            initialValues={{ photo: null as (File | Blob | null) }}
            enableReinitialize={true}
            maxWidth='xs'
            fullWidth
            validate={validateForm}

        >
            {({ values, errors, handleChange, setFieldValue, isSubmitting, dirty, setErrors }) => (
                <>
                    <UserPhotoInput
                        onChange={f => setFieldValue('photo', f)}
                        onError={e => setErrors({ photo: e })}
                        error={errors.photo}
                        key={'photo-key'}
                        value={values.photo}
                        src={!values.photo ? photoUrl : undefined}
                        notShowRemove
                    />
                    <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <DefaultButton
                            size='small'
                            type='submit'
                            variant="contained"
                            disabled={isSubmitting || !(values.photo instanceof File)}>
                            Salvar
                        </DefaultButton>
                        <ErrorButton
                            size='small'
                            variant="contained"
                            disabled={isSubmitting}
                            onClick={() => onCancel()}
                            style={{ marginLeft: 10 }}>
                            {t('cancel', { capitalize: true, namespace: 'form' })}
                        </ErrorButton>
                    </FormControl>
                </>
            )}
        </FormDialog>
    );

}

export default ChangePhotoDialog;